import { DraftDataDto } from "@green0meter/api-client";
import { isEmpty } from "lodash";
import type { FieldValues } from "react-hook-form/dist/types/fields";

/**
 * Build initial React Hook Form values object from draft data.
 * This is used both to:
 *  - seed RHF via reset(values)
 *  - provide initial/default values for useWatch during the first render
 */
export const getInitialFormValues = (
  formDraftData?: DraftDataDto[] | null,
): FieldValues => {
  const values: FieldValues = {};

  if (!formDraftData || isEmpty(formDraftData)) return values;

  formDraftData.forEach((draft) => {
    // TODO: fix typing on BE
    let value: object | string = draft.answerOptionCode ?? draft.value;

    if (draft.answerOptionCode) {
      value = draft.answerOptionCode as string;
    }

    values[
      draft.rowIndex
        ? `${draft.parentQuestionCode}-${draft.questionCode}-${draft.rowIndex}`
        : draft.parentQuestionCode
          ? `${draft.parentQuestionCode}-${draft.questionCode}`
          : draft.questionCode
    ] = value;

    if (draft.relevantYear) {
      values[`${draft.questionCode}-relevantYear`] = draft.relevantYear;
    }
  });

  return values;
};
